import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  Grid,
} from '@material-ui/core';
import {
  CloudUpload as UploadIcon,
  GetApp as DownloadIcon,
  Close as CloseIcon,
} from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { downloadTemplate } from 'utils/functions';
import styles from './styles';

function ImportModal(props) {
  const { t } = useTranslation();
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const getTypeConfig = () => {
    const configs = {
      products: {
        title: t('importModal.title.products'),
        description: t('importModal.description.products'),
      },
      employees: {
        title: t('importModal.title.employees'),
        description: t('importModal.description.employees'),
      },
      clients: {
        title: t('importModal.title.clients'),
        description: t('importModal.description.clients'),
      },
      suppliers: {
        title: t('importModal.title.suppliers'),
        description: t('importModal.description.suppliers'),
      },
    };
    return configs[props.type] || configs.products;
  };

  const config = getTypeConfig();

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file && props.onUploadFile) {
      props.onUploadFile(file);
    }
  };

  const handleDownloadTemplate = (type) => {
    if (type != 'products') {
      downloadTemplate(type);
    } else {
      const varietiesFromDB = Object.values(props.varieties || {})
        .filter((variety) => variety?.name && variety.name.trim())
        .map((variety) => variety.name.trim());

      const varietiesArray = varietiesFromDB;

      downloadTemplate(type, {
        Variedad: varietiesArray,
      });
    }
  };
  return (
    <Dialog
      open={props.isOpen}
      onClose={props.onClose}
      maxWidth="sm"
      fullWidth
      className={classes.dialog}>
      <DialogTitle className={classes.dialogTitle}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" component="h2">
            {config.title}
          </Typography>
          <IconButton onClick={props.onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <Typography variant="body2" color="textSecondary" className={classes.description}>
          {config.description}
        </Typography>

        <Box className={classes.actionsContainer}>
          <Grid container spacing={2}>
            {/* Upload Button */}
            <Grid item xs={6}>
              <input
                accept=".xlsx,.xls"
                style={{ display: 'none' }}
                id="upload-file-input"
                type="file"
                onChange={handleFileUpload}
              />
              <label htmlFor="upload-file-input">
                <Button
                  variant="outlined"
                  color="primary"
                  component="span"
                  fullWidth
                  startIcon={<UploadIcon />}
                  className={classes.uploadButton}
                  disabled={props.isUploading}>
                  {t('importModal.importExcel')}
                </Button>
              </label>
            </Grid>

            {/* Download Template Button */}
            <Grid item xs={6}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                startIcon={<DownloadIcon />}
                onClick={() => handleDownloadTemplate(props.type)}
                className={classes.downloadButton}>
                {t('importModal.downloadTemplate')}
              </Button>
            </Grid>
          </Grid>

          {/* Selected File Info */}
          {props.selectedFile && (
            <Box className={classes.fileInfo}>
              <Typography variant="body2" color="textPrimary">
                {t('importModal.selectedFile')} <strong>{props.selectedFile.name}</strong>
              </Typography>
            </Box>
          )}
        </Box>
      </DialogContent>

      <DialogActions className={classes.dialogActions}>
        <Button onClick={props.onClose} color="default" variant="outlined">
          {t('importModal.close')}
        </Button>
        <Button
          onClick={() => props.onImport(props.type)}
          color="primary"
          variant="contained"
          disabled={!props.selectedFile || props.isUploading}>
          {props.isUploading ? t('importModal.importing') : t('importModal.import')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ImportModal;
